import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Livraria } from "../types/general";

const defaultValues = {
  data: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalData: 0
  }
}

interface LivrariaZusProps {
  livrarias: {
    data: Livraria[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalData: number;
    };
  };
  selectedLivraria: Livraria | undefined;
  selectedLivrariaId: number | undefined;
  setLivrarias: (livrarias: { data: Livraria[]; pagination: any }) => void;
  setSelectedLivraria: (livraria: Livraria) => void;
  setSelectedLivrariaId: (livrariaId: number | undefined) => void;
  resetState: () => void;
  removeLivraria: (id: number) => void;
  updateLivraria: (livraria: Livraria) => void;
}

const useLivrariaStore = create<LivrariaZusProps>()(
  persist(
    (set, get) => ({
      livrarias: defaultValues,
      selectedLivraria: undefined,
      selectedLivrariaId: undefined,
      setLivrarias: (livrariasResponse) => {
        set({
          livrarias: {
            data: livrariasResponse.data || [],
            pagination: livrariasResponse.pagination || defaultValues.pagination
          }
        });
      },
      setSelectedLivraria: (livraria: Livraria) => {
        set({
          selectedLivraria: livraria
        });
      },
      setSelectedLivrariaId: (livrariaId: number | undefined) => {
        set({
          selectedLivrariaId: livrariaId
        });
      },
      resetState: () => {
        set({
          livrarias: defaultValues,
          selectedLivraria: undefined,
          selectedLivrariaId: undefined
        });
      },
      removeLivraria: (id: number) => {
        const { livrarias } = get();
        const newState = {
          ...livrarias,
          data: livrarias.data.filter((item) => id !== item.id)
        };
        set({
          livrarias: newState
        });
      },
      updateLivraria: (livraria: Livraria) => {
        const { livrarias } = get();
        const newState = {
          ...livrarias,
          data: livrarias.data.map((item) =>
            livraria.id === item.id ? livraria : item
          )
        };
        set({
          livrarias: newState,
          selectedLivraria: livraria
        });
      }
    }),
    {
      name: "livrarias",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useLivrariaStore;
